import { i18n } from '@client/i18n/i18n';
import { Interpolations } from '@drewjbartlett/i17n';

/**
 * A utility to generate a translation.
 */
export function $t(key: string, interpolations?: Interpolations): string {
  return i18n.t(key, interpolations);
}
